import { PropsWithoutRef } from 'react';
import HighchartsReact from 'highcharts-react-official';
import { colors } from 'commons/src/constants';

const spaceSparkLineConfig = ({
    data,
    graphStartAndEnd,
}: {
    data: { data: number[][]; id: string };
    graphStartAndEnd: { max: number; min: number };
}): PropsWithoutRef<HighchartsReact.Props> => ({
    chart: {
        backgroundColor: null,
        borderWidth: 0,
        type: 'line',
        margin: [2, 4, 2, 0],
        width: 140,
        height: 30,
        style: {
            overflow: 'visible',
        },
        // small optimalization, saves 1-2 ms each sparkline
        skipClone: true,
    },
    title: {
        text: '',
    },
    credits: {
        enabled: false,
    },
    xAxis: {
        labels: { enabled: false },
        startOnTick: false,
        endOnTick: false,
        min: graphStartAndEnd.min,
        max: graphStartAndEnd.max,
        tickPositions: [],
    },
    yAxis: {
        endOnTick: false,
        startOnTick: false,
        labels: { enabled: false },
        tickPositions: [0],
    },
    legend: { enabled: false },
    tooltip: { enabled: false },
    plotOptions: {
        series: {
            animation: false,
            lineWidth: 1,
            shadow: false,
            color: colors.greyShuttle,
            states: {
                hover: { enabled: false },
            },
            marker: {
                enabled: false,
            },
        },
        column: {
            borderRadius: 4,
        },
    },
    series: [data],
});

export default spaceSparkLineConfig;
